if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form[action="/cart/add"]');
      if (!this.form) return;
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.variantId = this.form.querySelector('input[name="id"]');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    enableLoading() {
      if (this.submitButton) {
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('loading');
      }
    }
    disableLoading() {
      if (this.submitButton) {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.classList.remove('loading');
      }
    }
    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton?.disabled) return;
      this.enableLoading();
      try {
        // Build form data
        const formData = new FormData(this.form);

        // Add to cart using fetch
        const response = await fetch('/cart/add', {
          method: 'POST',
          body: formData
        });
        if (!response.ok) {
          const responseData = await response.json();
          throw new Error(responseData.description || 'Error adding to cart');
        }
        // Get updated cart content
        const cartResponse = await fetch('?section_id=cart-drawer');
        const html = await cartResponse.text();
        const parser = new DOMParser();
        const cartHtml = parser.parseFromString(html, 'text/html');

        // Update cart drawer content
        if (this.cartDrawer) {
          const cartContent = cartHtml.querySelector('cart-drawer');

          if (cartContent) {
            this.cartDrawer.innerHTML = cartContent.innerHTML;
            this.cartDrawer.classList.remove('is-empty');
            this.cartDrawer.open();
          }
        }
      } catch (error) {
        console.error('Cart error:', error);
        // Show error to user
        const errorMessage = this.querySelector('.product-form__error-message');
        if (errorMessage) {
          errorMessage.textContent = error.message;
          errorMessage.classList.remove('hidden');
        }
      } finally {
        this.disableLoading();
      }
    }
  });
}
